import {
  CreateMpnActionType,
  CreateMpnActionTypes,
} from "./data";

const setStateValue = (key:CreateMpnActionTypes, value:any):CreateMpnActionType => ({
  type: key,
  payload: value,
});

export const CreateMpnActions = {
  setStateValue,
};
